import React, { useContext } from 'react'
import { AnimatePresence } from 'framer-motion/dist/framer-motion'

import { UIContext } from '../../../Context/UIContext'
import './Home.scss'

import Section from '../../Section'
import Logo from './Logo'
import Main from './Main'

const Intro = ({ data }) => {
    const { currentPage, showIntroLogo } = useContext(UIContext)

    return (
        <Section
            name="mga-home"
            className="mga-home-section"
            motionProps={{
                initial: false,
                animate: { opacity: 1 },
                exit: { opacity: 0, transition: { duration: 0.5 }},
                transition: { duration: 0.1 }
            }}
        >
            <AnimatePresence mode="wait">
                { currentPage === 'home' && showIntroLogo ? <Logo key="mga-home-logo" /> : <Main key="mga-home-main" data={data} /> }
            </AnimatePresence>
        </Section>
    )
}

export default React.memo(Intro)